(function() {
  // Mirror the swatch classes into ARIA so screen readers know what's picked
  function syncSwatch(el) {
    if (el.classList.contains('selected')) el.setAttribute('aria-current', 'true');
    else el.removeAttribute('aria-current');
    if (el.classList.contains('unselectable')) el.setAttribute('aria-disabled', 'true');
    else el.removeAttribute('aria-disabled');
  }

  function initSwatches() {
    var swatches = document.querySelectorAll('.product-detail [data-attr-value]');
    if (!swatches.length) return;
    var observer = new MutationObserver(function(records) {
      records.forEach(function(r) { syncSwatch(r.target); });
    });
    swatches.forEach(function(el) {
      syncSwatch(el);
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Flickity hides offscreen slides with aria-hidden but their links stay focusable
  function syncSlide(cell) {
    if (cell.getAttribute('aria-hidden') === 'true') cell.setAttribute('inert', '');
    else cell.removeAttribute('inert');
  }

  function watchSlider() {
    var slider = document.querySelector('.rec-slider');
    if (!slider) return;
    var observer = new MutationObserver(function(records) {
      records.forEach(function(r) {
        if (r.type === 'attributes') syncSlide(r.target);
      });
    });
    slider.querySelectorAll('.carousel-cell').forEach(function(cell) {
      syncSlide(cell);
      observer.observe(cell, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function init() {
    initSwatches();
    if (window.jQuery) {
      // Recommendations arrive by ajax, Flickity starts on this same event
      jQuery('body').on('recommendations:rendered', function() { setTimeout(watchSlider, 0); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
